import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, status: String, transcript: String }

  connect() {
    const waiting = this.statusValue === "processing" || this.transcriptValue === "pending" || this.transcriptValue === "processing"
    if (!waiting) return

    this.timer = window.setInterval(() => this.check(), 3000)
  }

  disconnect() {
    window.clearInterval(this.timer)
  }

  async check() {
    const response = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
    if (!response.ok) return
    const data = await response.json()
    if (data.status !== this.statusValue || data.transcript_status !== this.transcriptValue) {
      window.location.reload()
    }
  }
}
